import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import cancelSchedule from "./cancelScheduleService";
import { CancelActionContext } from "./CancelActionContext";

function useCancel(modelConfig: any) {
  const { elementId, setShowModal } = useContext(CancelActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    cancelSchedule(modelConfig.endpoint, elementId)
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useCancel;
